export const clientId = JSON.parse(localStorage.getItem('cliente') as string)?.codigo;
